// @generated by scripts/gen-modules.mjs
import { RouteObject, Navigate } from 'react-router-dom';
import { EmailRoutes } from './modules/email';
import { EmailAdvancedRoutes } from './modules/email-advanced';
import { LandingRoutes } from './modules/landing';
import { SuccessRoutes } from './modules/success';
import { LoyaltyRoutes } from './modules/loyalty';
import { CommunityRoutes } from './modules/community';

export const marketingRoutes: RouteObject[] = [
  { path: '', element: <Navigate to="email/campaigns" replace /> },
  EmailRoutes,
  EmailAdvancedRoutes,
  LandingRoutes,
  SuccessRoutes,
  LoyaltyRoutes,
  CommunityRoutes,
];

export default marketingRoutes;
